/**
 * GET `…/site-survey/site-survey-appointments?specialWorktype=…` for CAP Post Home Check.
 * Decoded value `Pre-Permit Check` encodes as `Pre-Permit+Check` in the query string per gateway.
 */
const SITE_SURVEY_APPOINTMENTS_SPECIAL_WORKTYPE_PRE_PERMIT_CHECK =
  "Pre-Permit Check";

const PPC_PRE_PERMIT_CHECK_SCHEDULED_CAP_REQ = "Pre-Permit Check Scheduled";

type OtherCapReqsField = string | string[] | null | undefined;

const otherCapReqFieldContains = (
  field: OtherCapReqsField,
  value: string
): boolean => {
  if (field == null || field === "") {
    return false;
  }

  if (Array.isArray(field)) {
    return field.some((entry) => entry.includes(value));
  }

  return field.includes(value);
};

const isPpcSchedulingRequired = (
  otherCapReqs: OtherCapReqsField,
  otherCapReqsFulfilled: OtherCapReqsField
): boolean =>
  otherCapReqFieldContains(
    otherCapReqs,
    PPC_PRE_PERMIT_CHECK_SCHEDULED_CAP_REQ
  ) &&
  !otherCapReqFieldContains(
    otherCapReqsFulfilled,
    PPC_PRE_PERMIT_CHECK_SCHEDULED_CAP_REQ
  );

const isPpcCompleteByOtherCapReqs = (
  otherCapReqs: OtherCapReqsField,
  otherCapReqsFulfilled: OtherCapReqsField
): boolean =>
  otherCapReqFieldContains(
    otherCapReqs,
    PPC_PRE_PERMIT_CHECK_SCHEDULED_CAP_REQ
  ) &&
  otherCapReqFieldContains(
    otherCapReqsFulfilled,
    PPC_PRE_PERMIT_CHECK_SCHEDULED_CAP_REQ
  );

const shouldHideCompletedPpcWithoutAppointment = (
  otherCapReqs: OtherCapReqsField,
  otherCapReqsFulfilled: OtherCapReqsField,
  appointmentsLoading: boolean,
  scheduledAppointment: unknown
): boolean =>
  isPpcCompleteByOtherCapReqs(otherCapReqs, otherCapReqsFulfilled) &&
  !appointmentsLoading &&
  scheduledAppointment == null;

const isLegacyPostCapHomeCheckNeeded = (
  postCapHomeCheckNeeded: string | null | undefined
): boolean =>
  typeof postCapHomeCheckNeeded === "string" &&
  postCapHomeCheckNeeded.includes("Check");

const isPostCapHomeCheckNeededByOtherCapReqs = (
  otherCapReqs: OtherCapReqsField
): boolean =>
  otherCapReqFieldContains(
    otherCapReqs,
    PPC_PRE_PERMIT_CHECK_SCHEDULED_CAP_REQ
  );

const shouldShowPostCapHomeCheckScheduler = (
  otherCapReqs: OtherCapReqsField,
  postCapHomeCheckNeeded: string | null | undefined,
  isPpcSchedulingInOneEnabled: boolean
): boolean =>
  isPpcSchedulingInOneEnabled &&
  (isPostCapHomeCheckNeededByOtherCapReqs(otherCapReqs) ||
    isLegacyPostCapHomeCheckNeeded(postCapHomeCheckNeeded));

/** Shown above the slot picker when scheduling from CAP Read & Sign. */
const POST_CAP_HOME_CHECK_SCHEDULE_SUBTITLE = `Sunrun may visit your home for a short review to capture final details before installation.
  Once you schedule, status may take a few minutes to update—refresh if needed.`;

const POST_CAP_HOME_CHECK_SLOTS_ERROR =
  "We had a problem loading appointments, please try again.";
const POST_CAP_HOME_CHECK_SLOTS_ERROR_RETRY = "Retry";

export {
  SITE_SURVEY_APPOINTMENTS_SPECIAL_WORKTYPE_PRE_PERMIT_CHECK,
  PPC_PRE_PERMIT_CHECK_SCHEDULED_CAP_REQ,
  otherCapReqFieldContains,
  isLegacyPostCapHomeCheckNeeded,
  isPostCapHomeCheckNeededByOtherCapReqs,
  isPpcCompleteByOtherCapReqs,
  isPpcSchedulingRequired,
  shouldHideCompletedPpcWithoutAppointment,
  shouldShowPostCapHomeCheckScheduler,
  POST_CAP_HOME_CHECK_SCHEDULE_SUBTITLE,
  POST_CAP_HOME_CHECK_SLOTS_ERROR,
  POST_CAP_HOME_CHECK_SLOTS_ERROR_RETRY,
};
export type { OtherCapReqsField };
